import React from 'react';
import { useContent } from '../../hooks/useContent';
import { ethicsEn } from '../../content/ethicsEn';
import styles from './Ethics.module.css';

const SECTION_IDS = ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8'];
const LINE_KEYS = [
  'line1',
  'line2',
  'line3',
  'line4',
  'line5',
  'line6',
  'line7',
  'line8',
  'line9',
  'line10',
  'line11',
  'line12',
];

/** Если в БД ошибочно лежит сам ключ i18n — не показывать его, взять локальный fallback. */
function normalizeEthicsLine(keyPath, resolved, fallback) {
  const s = String(resolved).trim();
  if (!s) return '';
  if (s === keyPath) return fallback;
  if (/^ethics\.sections\.s[1-8]\.line\d+$/.test(s)) return fallback;
  return resolved;
}

export default function Ethics() {
  const { t } = useContent();
  const def = ethicsEn;

  const sections = SECTION_IDS.map((id, index) => {
    const d = def.sections[id] || {};
    const lines = LINE_KEYS.map((lk) => {
      const keyPath = `ethics.sections.${id}.${lk}`;
      const fb = d[lk] ?? '';
      return normalizeEthicsLine(keyPath, t(keyPath, fb), fb);
    }).filter((x) => String(x).trim());
    return {
      id: index + 1,
      title: t(`ethics.sections.${id}.title`, d.title ?? ''),
      lines,
    };
  });

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>{t('ethics.pageTitle', def.pageTitle)}</h1>
        </div>
        <p className={styles.title}>
          {t('ethics.subtitleLine1', def.subtitleLine1)}
          <br />
          {t('ethics.subtitleLine2', def.subtitleLine2)}
        </p>
        <div className={styles.content}>
          {sections.map((s) => (
            <div key={s.id} className={styles.section}>
              <h2>{s.title}</h2>
              {s.lines.map((line, i) => (
                <p key={i}>{line.endsWith('.') ? line : `${line}`}</p>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.footer}>
        <p>{t('ethics.footerText', def.footerText)}</p>
      </div>
    </>
  );
}
